import { HttpRequest } from "../../api/core/request/HttpRequest";
import { RequestConstants } from "../../api/core/request/RequestConstants";
import { Dictionary } from "../../util/collection/Dictionary";
import { EventHandler } from "../../util/event/EventHandler";
import { LangLoaderUtil } from "../../util/lang/LangLoaderUtil";
/**
 * HelpLangRequest.ts
 */
export class HelpLangRequest {
    constructor(gameId, locale) {
        this.gameId = gameId;
        this.locale = locale;
        this.lang = new Dictionary();
        this.buildUrl();
    }
    load() {
        this.request = new HttpRequest(RequestConstants.GET, this.url);
        this.request.setContentType(RequestConstants.APPLICATION_JSON);
        this.request.setResponseType(RequestConstants.TEXT);
        this.request.onComplete(this.handleComplete, this);
        this.request.onError(this.handleError, this);
        this.request.send();
    }
    onComplete(handler, scope) {
        this.completeHandler = new EventHandler(handler, scope);
    }
    getLang() {
        return this.lang;
    }
    buildUrl() {
        this.url = LangLoaderUtil.getHelpLangOrigin();
        this.url += 'rgs/lang/help/' + this.gameId + '/' + this.locale + '.json?' + Date.now();
    }
    handleComplete() {
        let lang = this.request.getJSON();
        for (let key in lang) {
            this.processItem(key, lang[key]);
        }
        this.completeHandler.call(this);
    }
    handleError() {
        if (this.locale !== "en-GB") {
            console.error("Help Lang Failed - trying en-GB");
            this.locale = "en-GB";
            this.buildUrl();
            this.load();
        }
        else {
            console.error("Help Lang Failed");
            this.completeHandler.call(this);
        }
    }
    processItem(id, value) {
        this.lang.setValue(id, value);
    }
}
//# sourceMappingURL=HelpLangRequest.js.map